module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloude-airplane-mobile-6a4212c9d9c1848180d32b8dbadb8504.svg";